import { render, staticRenderFns } from "./MailDelivery.vue?vue&type=template&id=61d75d2a&"
import script from "./MailDelivery.vue?vue&type=script&lang=js&"
export * from "./MailDelivery.vue?vue&type=script&lang=js&"
import style0 from "./MailDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports